import { cva } from "class-variance-authority";
export { default as FileType } from "./FileType";

export const variants = cva([], {
    variants: {
        size: {
            xs: "w-4 h-4",
            sm: "w-6 h-6",
            md: "w-8 h-8",
            lg: "w-10 h-10",
        },
    },
});

export const extensions = {
    images: {
        img: "img",
        jpg: "jpg",
        jpeg: "jpeg",
        png: "png",
        webp: "webp",
        tiff: "tiff",
        gif: "gif",
        svg: "svg",
        eps: "eps",
        // unsupported - fallback
        bmp: "image",
        ico: "image",
        heic: "image",
        heif: "image",
    },
    docs: {
        pdf: "pdf",
        doc: "doc",
        docx: "docx",
        txt: "txt",
        csv: "csv",
        xls: "xls",
        xlsx: "xlsx",
        ppt: "ppt",
        pptx: "pptx",
        // unsupported - fallback
        odt: "document",
        ods: "spreadsheet",
        odp: "document",
        md: "document",
        rtf: "document",
        pages: "document",
        sheets: "spreadsheet",
    },
    vector: {
        fig: "fig",
        ai: "ai",
        psd: "psd",
        indd: "indd",
        aep: "aep",
        // unsupported - fallback
        svg: "image",
        gs: "image",
        eps: "image",
    },
    multimedia: {
        mp3: "mp3",
        wav: "wav",
        mp4: "mp4",
        mpeg: "mpeg",
        avi: "avi",
        mkv: "mkv",
        mov: "mov",
        // unsupported - fallback
        aif: "audio",
        midi: "video2",
        aac: "audio",
        flac: "audio",
        ogg: "audio",
        m4a: "audio",
        wma: "video",
        wmv: "video2",
    },
    archive: {
        zip: "zip",
        rar: "rar",
        // unsupported - fallback
        iso: "empty",
        pkg: "empty",
        tar: "folder",
        gz: "folder",
        "7z": "folder",
    },
    code: {
        html: "html",
        css: "css",
        rss: "rss",
        sql: "sql",
        js: "js",
        json: "json",
        java: "java",
        xml: "xml",
        exe: "exe",
        dmg: "dmg",
        // unsupported - fallback
        sh: "code",
        bash: "code",
        bat: "code",
        ps1: "code",
        ts: "code",
        jsx: "code",
        tsx: "code",
        vue: "code",
        php: "code",
        py: "code",
        rb: "code",
        go: "code",
        swift: "code",
        kotlin: "code",
        dart: "code",
        c: "code",
        cpp: "code",
        cs: "code",
    },
    generic: {
        empty: "empty",
        folder: "folder",
        image: "image",
        video: "video",
        video2: "video2",
        audio: "audio",
        pdf2: "pdf2",
        document: "document",
        spreadsheet: "spreadsheet",
        code: "code",
        default: "empty",
    },
};
